import { getDefaultI18n } from './chunk-2UGAFJLN.js';
import { Button } from './chunk-UDB35RLY.js';
import { cn } from './chunk-FFX3LZW7.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { AlertTriangle, RotateCw } from 'lucide-react';
import { toErrorResponse } from '@authe/fe-commons/errors';
import { messageForError } from '@authe/fe-commons/i18n';

var SIZES = {
  sm: "py-6",
  md: "py-10",
  lg: "py-16"
};
function EmptyState({
  title,
  description,
  icon,
  action,
  className,
  size = "md"
}) {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "flex flex-col items-center justify-center text-center",
        SIZES[size],
        className
      ),
      children: [
        icon && /* @__PURE__ */ jsx("div", { className: "mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-muted text-muted-foreground", children: icon }),
        /* @__PURE__ */ jsx("p", { className: "text-sm font-semibold", children: title }),
        description && /* @__PURE__ */ jsx("p", { className: "mt-1 max-w-sm text-sm text-muted-foreground", children: description }),
        action && /* @__PURE__ */ jsx("div", { className: "mt-4", children: action })
      ]
    }
  );
}
var SIZES2 = {
  sm: "py-6",
  md: "py-10",
  lg: "py-16"
};
function ErrorState({
  error,
  i18n,
  title,
  onRetry,
  retryLabel = "Try again",
  className,
  size = "md"
}) {
  const response = toErrorResponse(error);
  const resolved = messageForError(response.error, i18n ?? getDefaultI18n() ?? void 0);
  return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-col items-center justify-center text-center", SIZES2[size], className), children: [
    /* @__PURE__ */ jsx("div", { className: "mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-destructive/10 text-destructive", children: /* @__PURE__ */ jsx(AlertTriangle, { className: "h-6 w-6" }) }),
    /* @__PURE__ */ jsx("p", { className: "text-sm font-semibold", children: title ?? resolved.description }),
    resolved.userAction && /* @__PURE__ */ jsx("p", { className: "mt-1 max-w-sm text-sm text-muted-foreground", children: resolved.userAction }),
    response.error.correlation_id && /* @__PURE__ */ jsxs("p", { className: "mt-2 font-mono text-xs text-muted-foreground/70", children: [
      "ref: ",
      response.error.correlation_id
    ] }),
    onRetry && /* @__PURE__ */ jsxs(Button, { variant: "outline", size: "sm", className: "mt-4 gap-2", onClick: onRetry, children: [
      /* @__PURE__ */ jsx(RotateCw, { className: "h-3.5 w-3.5" }),
      retryLabel
    ] })
  ] });
}

export { EmptyState, ErrorState };
//# sourceMappingURL=chunk-SDWPVCDA.js.map
//# sourceMappingURL=chunk-SDWPVCDA.js.map